<template>
  <div id="customerBusiness">
    <b-container fluid class="p-0">
      <main>
        <div>
          <dl class="m-0 d-flex justify-content-between text-aligns-center">
            <dt class="mb-0" style="display: inline-block;">
              <CommonTitle class="sp-h2-font-size fs-24-bold" :titleProps="'お客様情報の確認'"/>
            </dt>
            <dd class="mb-0">
              <b-button variant="primary" href="/mypage/change_request/input" class="fs-14-bold mb-0" pill type="button">変更を依頼する</b-button>
            </dd>
          </dl>
        </div>
        <!-- コンテンツ領域 -->
        <b-card class="m-0 p-0">
          <b-row>
            <!-- お客様のコース情報 -->
            <b-col cols="12" class="mb-1">
              <h2 class="fs-18-bold">業務内容</h2>
            </b-col>
            <b-col cols="12">
              <div>
                <div class="bg-white">
                  <b-row>
                    <b-col md="6" sm="12" class="mb-3">
                      <dl class="info h-100 m-0"><dt class="info-title fs-12-bold">応対者名</dt><dd class="info-desc fs-14-regular">{{ receptionStaffName }}</dd></dl>
                    </b-col>
                    <b-col md="6" sm="12" class="mb-3">
                      <dl class="info h-100 m-0"><dt class="info-title fs-12-bold">業種</dt><dd class="info-desc fs-14-regular">{{ activityDetail }}</dd></dl>
                    </b-col>
                  </b-row>
                </div>
                <p class="fs-12-bold mb-3">対応曜日時間帯</p>
                <div class="box-time bg-white">
                  <b-row>
                    <b-col md="12" sm="12" lg="6" class="mb-3">
                      <div class="box-time-col-1 h-100 m-0">
                        <div class="d-flex align-items-center flex-nowrap mb-3">
                          <b-form-radio v-model="selected" value="" disabled class="pl-2"></b-form-radio>
                          <label class="check-box-label mr-2 text-nowrap fs-12-bold">平日</label>
                          <div class="d-flex align-items-center w-100 time-input-only-read">
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(start_time_weekday)" class="time-start fs-14-regular"></b-form-input>
                            </div>
                            <div class="icon-between btn d-inline-flex align-items-center justify-content-center fs-14-regular">〜</div>
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(end_time_weekday)" class="time-end fs-14-regular"></b-form-input>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center flex-nowrap mb-3">
                          <b-form-radio v-model="selected" value="" disabled class="pl-2"></b-form-radio>
                          <label class="check-box-label mr-2 text-nowrap fs-12-bold">土曜</label>
                          <div class="d-flex align-items-center w-100 time-input-only-read">
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(start_time_saturday)" class="time-start fs-14-regular"></b-form-input>
                            </div>
                            <div class="icon-between btn d-inline-flex align-items-center justify-content-center fs-14-regular">〜</div>
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(end_time_saturday)" class="time-end fs-14-regular"></b-form-input>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center flex-nowrap mb-3 no-mb-mobile">
                          <b-form-radio v-model="selected" value="" disabled class="pl-2"></b-form-radio>
                          <label class="check-box-label mr-2 text-nowrap fs-12-bold">日祝</label>
                          <div class="d-flex align-items-center w-100 time-input-only-read">
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(start_time_sunday_and_holiday)" class="time-start fs-14-regular"></b-form-input>
                            </div>
                            <div class="icon-between btn d-inline-flex align-items-center justify-content-center fs-14-regular">〜</div>
                            <div class="wrap-time-input position-relative w-100">
                              <img src="../../assets/ico-clock.svg">
                              <b-form-input disabled :value="formatTime(end_time_sunday_and_holiday)" class="time-end fs-14-regular"></b-form-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col md="12" sm="12" lg="6" class="mb-3">
                      <div class="box-time-col-2 h-100 m-0">
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="bg-white">
                  <b-row>
                    <b-col md="6" sm="12" class="mb-3">
                      <div class="info h-100 m-0 checkbox-answer-sale">
                        <label class="check-box-label pt-1" :class="isForAnswerSalesAndBusiness ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isForAnswerSalesAndBusiness" class="check-box-input"  aria-disabled="true" disabled/>セールスNG</label>
                      </div>
                    </b-col>
                    <b-col md="6" sm="12" class="mb-3">
                      <dl class="info h-100 m-0"><dt class="info-title fs-12-bold">公表するホームページURL</dt><dd class="info-desc fs-14-regular">{{ announceHomepageUrl }}</dd></dl>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col cols="12"><hr class="mt-0"></b-col>
            <b-col cols="12" class="mb-3">
              <h2 class="fs-16-bold mb-0">オプション業務</h2>
            </b-col>
            <b-col cols="12">
              <div class="bg-white">
                <b-row>
                  <b-col md="6" sm="12" class="mb-3">
                    <div class="info h-100 m-0">
                      <label class="check-box-label mb-3" :class="isEmailReport ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isEmailReport" class="check-box-input" aria-disabled="true" disabled/>E-Mail報告</label>
                      <label class="check-box-label mb-3" :class="isFaxReport ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isFaxReport" class="check-box-input" aria-disabled="true" disabled/>FAX報告</label>
                      <label class="check-box-label mb-3" :class="isQa ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isQa" class="check-box-input" aria-disabled="true" disabled/>Q＆A追加</label>
                      <label class="check-box-label mb-3" :class="isHearing ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isHearing" class="check-box-input" aria-disabled="true" disabled/>聴取項目追加</label>
                      <label class="check-box-label mb-3" :class="isSpecialSystem ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isSpecialSystem" class="check-box-input" aria-disabled="true" disabled/>特殊システム</label>
                      <label class="check-box-label mb-3" :class="isMultiLanguage ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isMultiLanguage" class="check-box-input" aria-disabled="true" disabled/>多言語サービス3者間通話</label>
                    </div>
                  </b-col>
                  <b-col md="6" sm="12" class="mb-3">
                    <div class="info h-100 m-0">
                      <label class="check-box-label mb-3" :class="isTelephoneReport ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isTelephoneReport" class="check-box-input" aria-disabled="true" disabled/>電話報告</label>
                      <label class="check-box-label mb-3" :class="isTransfer ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isTransfer" class="check-box-input" aria-disabled="true" disabled/>取次転送</label>
                      <label class="check-box-label mb-3" :class="isProduct ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isProduct" class="check-box-input" aria-disabled="true" disabled/>取り扱い商材追加</label>
                      <label class="check-box-label mb-3" :class="isBusinessReport ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isBusinessReport" class="check-box-input" aria-disabled="true" disabled/>業務報告書作成</label>
                      <label class="check-box-label mb-3" :class="isBusinessEndReportExcelFlag ? 'fs-12-bold' : 'fs-12-regular'"><input type="checkbox" v-model="isBusinessEndReportExcelFlag" class="check-box-input" aria-disabled="true" disabled/>業務終了時エクセル報告</label>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="bg-white">
                <b-row>
                  <b-col md="6" sm="12" class="mb-3" v-if="businessOptionValue">
                    <dl class="info h-100 m-0"><dt class="info-title fs-12-bold">顧客オリジナルアナウンス</dt><dd class="info-desc fs-14-regular">{{ businessOptionValue }}</dd></dl>
                  </b-col>
                  <b-col md="6" sm="12" class="mb-3">
                    <dl class="info h-100 m-0"><dt class="info-title fs-12-bold">受信回線数</dt><dd class="info-desc fs-14-regular">{{ receiveCountValue }}</dd></dl>
                  </b-col>
                  <b-col md="6" sm="12">
                    <dl class="h-100 m-0"><dt class="info-title fs-12-bold">連絡先FAX番号</dt><dd class="info-desc fs-14-regular">{{ targetFax }}</dd></dl>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </main>
    </b-container>
    <!-- ローディング -->
    <b-modal centered :title="isLoadingTxt" v-model="loadingModalShow" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
      <CommonLoader :title="isLoadingTxt"/>
    </b-modal>
  </div>
</template>
<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../utils/loading-text-util'

// NOTE: 共通タイトルUI
import CommonTitle from '../../components/common/CommonTitle'

// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../utils/toast-text-util'

// NOTE: 共通エラー処理
import ErrorHandleUtil from '@/utils/error-handle-util'
import CommonLoader from '@/components/common/CommonLoader.vue'

export default {
  components: {
    CommonLoader,
    CommonTitle
  },
  data () {
    return {
      tasId: '',
      selected: '',
      last_login_date: '',
      account_id: '',
      isLoadingTxt: '',
      loadingModalShow: false,

      activityDetail: '',
      announceHomepageUrl: '',
      contractWeekdayStartTime: '',
      contractWeekdayEndTime: '',
      contractSaturdayStartTime: '',
      contractSaturdayEndTime: '',
      contractSundayStartTime: '',
      contractSundayEndTime: '',
      isForAnswerSalesAndBusiness: '',
      isFaxReportRequired: '',
      isBusinessReportRequired: '',
      isSpecialSystemRequired: '',
      isScheduleBookingDailyRequired: '',
      isMultiLanguageRequired: '',
      mailReportSendTypeRequired: '',
      overtimeAnnounce: '',
      optionInboundLineCount: '',
      optionBusinessEndReportTelephoneFlag: '',
      optionBusinessEndReportMailFlag: '',
      optionBusinessEndReportFaxFlag: '',
      endReport: '',
      receptionStaffName: '',
      businessOptionValue: '',
      receiveCountValue: '',
      isBusinessEndReportExcelFlag: '',
      isBusinessReport: '',
      isEmailReport: '',
      isFaxReport: '',
      isHearing: '',
      isMultiLanguage: '',
      isProduct: '',
      isQa: '',
      isSpecialSystem: '',
      isTelephoneReport: '',
      isTransfer: '',
      targetFax: '',
      isTargetTelephoneNumber: '',
      isNonNotification: '',
      start_time_weekday: '',
      end_time_weekday: '',
      start_time_saturday: '',
      end_time_saturday: '',
      start_time_sunday_and_holiday: '',
      end_time_sunday_and_holiday: '',
      business_saturday_24hr_open_flag: '',
      business_sunday_24hr_open_flag: '',
      business_weekday_24hr_open_flag: '',
      business_holiday_24hr_open_flag: '',
      end_holiday_time_value: '',
      end_saturday_time_value: '',
      end_sunday_time_value: '',
      end_weekday_time_value: '',
      start_holiday_time_value: '',
      start_saturday_time_value: '',
      start_sunday_time_value: '',
      start_weekday_time_value: ''
    }
  },
  mounted () {
    this.getUserBusiness()
    this.$emit('executionUnreadCount')
    this.tasId = sessionStorage.getItem('tas_id')
    this.account_id = sessionStorage.getItem('account_id')
    document.querySelector('.main-setting').scrollTop = 0
  },
  computed: {
    weekday_service_time () {
      if (this.start_time_weekday == null || this.end_time_weekday == null) {
        return ''
      }
      return this.start_time_weekday.slice(0, -3) + '〜' + this.end_time_weekday.slice(0, -3)
    },
    saturday_service_time () {
      if (this.start_time_saturday == null || this.end_time_saturday == null) {
        return ''
      }
      return this.start_time_saturday.slice(0, -3) + '〜' + this.end_time_saturday.slice(0, -3)
    },
    sunday_and_holiday_service_time () {
      if (this.start_time_sunday_and_holiday == null || this.end_time_sunday_and_holiday == null) {
        return ''
      }
      return this.start_time_sunday_and_holiday.slice(0, -3) + '〜' + this.end_time_sunday_and_holiday.slice(0, -3)
    },
    weekday_business_time () {
      if (this.business_weekday_24hr_open_flag) {
        return '24時間'
      }
      if (this.start_weekday_time_value == null || this.end_weekday_time_value == null) {
        return ''
      }
      return this.start_weekday_time_value.slice(0, -3) + '〜' + this.start_weekday_time_value.slice(0, -3)
    },
    saturday_business_time () {
      if (this.business_saturday_24hr_open_flag) {
        return '24時間'
      }
      if (this.start_saturday_time_value == null || this.end_saturday_time_value == null) {
        return ''
      }
      return this.start_saturday_time_value.slice(0, -3) + '〜' + this.end_saturday_time_value.slice(0, -3)
    },
    sunday_business_time () {
      if (this.business_sunday_24hr_open_flag) {
        return '24時間'
      }
      if (this.start_sunday_time_value == null || this.end_sunday_time_value == null) {
        return ''
      }
      return this.start_sunday_time_value.slice(0, -3) + '〜' + this.end_sunday_time_value.slice(0, -3)
    },
    holiday_business_time () {
      if (this.business_holiday_24hr_open_flag) {
        return '24時間'
      }
      if (this.start_holiday_time_value == null || this.end_holiday_time_value == null) {
        return ''
      }
      return this.start_holiday_time_value.slice(0, -3) + '〜' + this.end_holiday_time_value.slice(0, -3)
    }
  },
  methods: {
    /**
     * お客様情報をAPIで取得
     * */
    getUserBusiness () {
      // APIでアイテム取得
      this.isLoadingTxt = LoadingTxt.getTxt
      this.loadingModalShow = true
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/mypage/getUserBusiness'
      this.$axios.request({
        method: 'get',
        url: `${url}`,
        params: {
          customer_id: sessionStorage.getItem('customer_id')
        },
        withCredentials: true }).then(response => {
        if (response.data.result_code === 403) {
          // セッション切れたのでログイン画面に飛ぶ
          if (this.$route.path !== '/mypage/login') this.$router.push({ path: '/mypage/login' })
        }
        if (response.data.error_message) {
          // 取得失敗
          this.$bvToast.toast(
            response.data.error_message,
            {
              title: ToastTextUtil.errorTitle,
              variant: 'danger',
              noAutoHide: true,
              toaster: 'b-toaster-top-center'
            }
          )
        }
        if (response.data.code === 2000) {
          // 取得成功
          let dutiesContents = response.data.duties_contents
          let businessOption = dutiesContents.business_option
          let endReport = dutiesContents.end_report
          this.activityDetail = dutiesContents.activity_detail
          this.isForAnswerSalesAndBusiness = dutiesContents.is_for_answer_sales_and_business
          this.announceHomepageUrl = dutiesContents.announce_homepage_url
          this.receptionStaffName = this.selectedValue(dutiesContents.reception_staff_name_selected, dutiesContents.reception_staff_name_options)
          // 時間外アナウンスが「顧客オリジナルアナウンス」の時のみ「利用あり」と表示
          if (businessOption.off_hour_announce_selected === '112') {
            this.businessOptionValue = '利用あり'
          }
          this.receiveCountValue = this.selectedValue(businessOption.receive_count_selected, businessOption.receive_count_options)
          this.isEmailReport = businessOption.is_email_report
          this.isBusinessEndReportExcelFlag = businessOption.is_business_end_report_excel_flag
          this.isBusinessReport = businessOption.is_business_report
          this.isFaxReport = businessOption.is_fax_report
          this.isHearing = businessOption.is_hearing
          this.isMultiLanguage = businessOption.is_multi_language
          this.isProduct = businessOption.is_product
          this.isQa = businessOption.is_qa
          this.isSpecialSystem = businessOption.is_special_system
          this.isTelephoneReport = businessOption.is_telephone_report
          this.isTransfer = businessOption.is_transfer
          this.optionBusinessEndReportFaxFlag = endReport.is_fax_report
          this.optionBusinessEndReportMailFlag = endReport.is_mail_report
          this.optionBusinessEndReportTelephoneFlag = endReport.is_telephone_report
          this.targetFax = dutiesContents.target_fax
          this.isTargetTelephoneNumber = dutiesContents.is_target_telephone_number
          this.isNonNotification = dutiesContents.isNonNotification
          this.start_time_weekday = dutiesContents.course_start_time_weekday_time
          this.end_time_weekday = dutiesContents.course_end_time_weekday_time
          this.start_time_saturday = dutiesContents.course_start_time_saturday_time
          this.end_time_saturday = dutiesContents.course_end_time_saturday_time
          this.start_time_sunday_and_holiday = dutiesContents.course_start_time_sunday_and_holiday_time
          this.end_time_sunday_and_holiday = dutiesContents.course_end_time_sunday_and_holiday_time
          this.business_saturday_24hr_open_flag = dutiesContents.business_saturday_24hr_open_flag
          this.business_sunday_24hr_open_flag = dutiesContents.business_sunday_24hr_open_flag
          this.business_weekday_24hr_open_flag = dutiesContents.business_weekday_24hr_open_flag
          this.business_holiday_24hr_open_flag = dutiesContents.business_holiday_24hr_open_flag
          this.end_holiday_time_value = dutiesContents.end_holiday_time_value
          this.end_saturday_time_value = dutiesContents.end_saturday_time_value
          this.end_sunday_time_value = dutiesContents.end_sunday_time_value
          this.end_weekday_time_value = dutiesContents.end_weekday_time_value
          this.start_holiday_time_value = dutiesContents.start_holiday_time_value
          this.start_saturday_time_value = dutiesContents.start_saturday_time_value
          this.start_sunday_time_value = dutiesContents.start_sunday_time_value
          this.start_weekday_time_value = dutiesContents.start_weekday_time_value
        }
      }).catch(err => {
        console.log(err)
        if (ErrorHandleUtil.authErrorHandle(err, this.$route.path, this.$router)) return
        this.$bvToast.toast(
          '通信エラー',
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      }).finally(() => {
        if (this.payment_method_now_changing_flag_front !== 0) {
          this.loadingModalShow = false
        } else {
          this.loadingModalShow = false
        }
      })
    },
    isEmpty (obj) {
      if (obj === null) {
        return true
      }
      return !Object.keys(obj).length
    },
    selectedValue (value, obj) {
      if (value === -1) {
        return ''
      }
      let selected = obj.find(object => object.value === value)

      if (selected) {
        return selected.text
      }
      return ''
    },
    dateTimeFormat (dateTime) {
      return dateTime.replace(/-/g, '/')
    },
    formatTime (timeString) {
      if (!timeString) return timeString
      const [hours, minutes] = timeString.split(':')
      const formattedHours = parseInt(hours, 10) % 24
      return `${formattedHours}:${minutes}`
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.info-title {
  display: block;
  background: transparent;
  height: auto;
  padding: 0;
  margin: 0;
  border-radius: 0;
}

.box-time-col-1,
.box-time-col-2,
.info{
  border-bottom: 2px dashed var(--secondary);
}

.info-desc{
  min-height: 1.25rem;
}

hr{
  border-top: 1px solid #CED2D5;
}
.time-input-only-read{
  .wrap-time-input{
    img {
      position: absolute;
      top: 50%;
      left: 0.5rem;
      transform: translateY(-50%);
    }

    input{
      padding: 0.5rem;
      background-color: #fff;
      padding-left: 1.625rem;

      &.time-start{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &.time-end{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

  }

  .icon-between{
    border: 1px solid var(--secondary);
    background-color: #ECEFF2;
    border-radius: 0;
    border-right: 0;
    border-left: 0;
    width: 30px;
    height: 30px;
  }
}

@media screen and (max-width: 992px) {
  .box-time-col-1{
    border-bottom: 0;
  }

  .no-mb-mobile{
    margin-bottom: 0 !important;
  }

  .checkbox-answer-sale{
    padding-bottom: 1rem;
  }
}
</style>
<style lang="scss">
#customerBusiness{
  .check-box-label {
    display: flex;
    margin-bottom: 0;
    align-items: center;
  }

  .check-box-input::after{
    left: 0.3rem !important;
  }
}
@media screen and (max-width: 480px) {
    .sp-h1-font-size {
      font-size: 1.5rem !important;
    }
    .sp-h2-font-size {
      font-size: 1.25rem !important;
    }
    .sp-h3-font-size {
      font-size: 1.2rem !important;
    }
    .sp-botton-font-size {
      font-size: 0.6rem !important;
    }
    .sp-table-label-font-size {
      font-size: 0.8rem !important;
    }
    .info {
      display: flex;
      flex-direction: column;
    }
    .info-title {
      width: max-content;
    }
}

.info-desc {
  display: inline-block;
  margin-bottom: 0;
}

.check-box-input {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-right: 6px;
}

.check-box-input:checked {
  background: #0088ff;
  border: 1px solid #0088ff;
  position: relative;
}

.check-box-input:checked::after {
  content: "";
  display: block;
  width: 5px;
  height: 10px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 0;
  left: 3.5px;
}
</style>
